
export const OVERALL_PERF_VIEW = 'OVERALL_PERF_VIEW';
export const OVERALL_PERF_EVENT = 'OVERALL_PERF_EVENT';
export const COST_PER_CONVERSION = 'COST_PER_CONVERSION';
export const REVENUE_PER_CONVERSION = 'REVENUE_PER_CONVERSION';